export const CATEGORIES_RESET_STATE = 'CATEGORIES_RESET_STATE';
export const CATEGORIES_CURRENT_ITEM = 'CATEGORIES_CURRENT_ITEM';

export const CATEGORIES_REQUEST_LOADING = 'CATEGORIES_REQUEST_LOADING';
export const CATEGORIES_REQUEST_SUCCESS = 'CATEGORIES_REQUEST_SUCCESS';
export const CATEGORIES_REQUEST_FAILED = 'CATEGORIES_REQUEST_FAILED';

export const CATEGORIES_CURRENT_ACTION = 'CATEGORIES_CURRENT_ACTION';
export const CATEGORIES_RESET_ACTION = 'CATEGORIES_RESET_ACTION';